export const isAndroidBrowser = () => /Android/i.test(navigator.userAgent || '');

export const isiOSBrowser = () => /iPhone|iPad|iPod/i.test(navigator.userAgent || '');

export const isAndroidOriOSBrowser = () => isAndroidBrowser() || isiOSBrowser();
